import { useEffect, useRef, useState } from 'react';
import { copyToClipboard, hideSuccessCopyTimeout } from 'utils';

export interface CopyableItemConfig {
  id: string;
  partialCopyId?: string; // when in '22.24 USD' you need to copy only '22.24'
  title: string;
  value: string | React.ReactNode;
}

export const useCopyableItems = (itemConfigs: CopyableItemConfig[]) => {
  const [copiedStates, setCopiedStates] = useState<Record<string, boolean>>({});
  const timeoutRef = useRef<NodeJS.Timeout>();

  const handleCopy = (id: string, partialCopyId?: string) => () => {
    copyToClipboard(id, partialCopyId);
    setCopiedStates((prev) => ({
      ...prev,
      [id]: true,
    }));
    timeoutRef.current = hideSuccessCopyTimeout((resetState: boolean) => {
      setCopiedStates((prev) => ({
        ...prev,
        [id]: resetState,
      }));
    });
  };

  const copyableItems = itemConfigs.map((config) => ({
    ...config,
    isCopied: copiedStates[config.id] || false,
    onCopy: handleCopy(config.id, config.partialCopyId),
  }));

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return {
    copyableItems,
  };
};
